<nz-card nzTitle="Visitation data" [nzExtra]="extraTemplate">
  <nz-skeleton [nzActive]="true" [nzLoading]="(loading$ | async) ?? false">
    <ng-container *ngIf="error$ | async as errorMsg; else resultTemplate">
      <nz-result
        nzStatus="error"
        nzTitle="SharePoint gave an error"
        [nzSubTitle]="errorMsg"
      ></nz-result>
    </ng-container>

    <ng-template #extraTemplate>
      <!-- Use stopPropagation so the panel doesn't toggle when clicking the link -->
      <a target="_blank" rel="external" [href]="siteUrl" (click)="$event.stopPropagation()">
        <i nz-icon nzType="link"></i>
        Open SharePoint Site
      </a>
    </ng-template>
  </nz-skeleton>
</nz-card>

<ng-template #resultTemplate>
  <ng-container *ngIf="visitation$ | async as visitation; else noData">
    <nz-descriptions [nzColumn]="4" nzLayout="vertical">
      <nz-descriptions-item nzTitle="Order type">
        <em-display-property [value]="visitation.orderType"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Part number">
        <em-display-property [value]="visitation.partNumber"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="C64 Date">
        <em-display-property
          [value]="(visitation.c64Date | date: 'shortDate') ?? ''"
        ></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Material 1">
        <em-display-property [value]="visitation.material1"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Material 2">
        <em-display-property [value]="visitation.material2"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Planning status">
        <em-display-property [value]="visitation.planningStatus"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Dev segment">
        <em-display-property [value]="visitation.devSegment"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Mould definition">
        <em-display-property [value]="visitation.mouldDefinition"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Mould type">
        <em-display-property [value]="visitation.mouldType"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Cavities">
        <em-display-property [value]="visitation.cavities"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="MM profile">
        <em-display-property [value]="visitation.mmProfile"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="MQ profile">
        <em-display-property [value]="visitation.mqProfile"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Mould 1 plant">
        <em-display-property [value]="visitation.mould1Plant"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Ted start">
        <em-display-property
          [value]="(visitation.tedStart | date: 'shortDate') ?? ''"
        ></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Ted end C45">
        <em-display-property
          [value]="(visitation.tedEndC45 | date: 'shortDate') ?? ''"
        ></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="PTY start">
        <em-display-property
          [value]="(visitation.ptyStart | date: 'shortDate') ?? ''"
        ></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="PTY end C46">
        <em-display-property
          [value]="(visitation.ptyEndC46 | date: 'shortDate') ?? ''"
        ></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="PTY eval start">
        <em-display-property
          [value]="(visitation.ptyEvalStart | date: 'shortDate') ?? ''"
        ></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="PTY eval end C47">
        <em-display-property
          [value]="(visitation.ptyEvalEndC47 | date: 'shortDate') ?? ''"
        ></em-display-property>
      </nz-descriptions-item>
    </nz-descriptions>

    <div nz-row nzJustify="end">
      <a target="_blank" rel="external" [href]="visitation.webUrl">
        <em-display-property [value]="visitation.fileName"></em-display-property>
        <i class="icon" nz-icon nzType="file-excel" nzTheme="twotone" nzTwotoneColor="5914fa"></i>
      </a>
    </div>
  </ng-container>
</ng-template>

<ng-template #noData>
  <nz-empty></nz-empty>
</ng-template>
